import { BidiModule } from "@angular/cdk/bidi";
import { registerLocaleData } from "@angular/common";
import {
    HTTP_INTERCEPTORS,
    HttpClient,
    HttpClientModule,
} from "@angular/common/http";
import arSaLocale from "@angular/common/locales/ar-EG";
import { LOCALE_ID, NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSliderModule } from "@angular/material/slider";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { NgxImageZoomModule } from "ngx-image-zoom";
import { OwlModule } from "ngx-owl-carousel";
import { NgxPaginationModule } from "ngx-pagination";
import {
    PERFECT_SCROLLBAR_CONFIG,
    PerfectScrollbarConfigInterface,
    PerfectScrollbarModule,
} from "ngx-perfect-scrollbar";
import { ToastaModule } from "ngx-toasta";
import { SwiperModule } from "swiper/angular/";
import { LoadingBarModule } from "@ngx-loading-bar/core";
import { LoadingBarRouterModule } from "@ngx-loading-bar/router";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { AppRoutes } from "./app-routing";
import { AppComponent } from "./app.component";
import { AuthLoginGuard } from "./Core/guards/auth-login.guard";
import { AuthGuard } from "./Core/guards/auth.guard";
import { MenuItems } from "./Core/menu/menu-items/menu-items";
import { GlobalModule } from "./Global/Global.module";
import { NotificationsComponent } from "./Global/notifications/notifications.component";
import { FooterOneComponent } from "./Layouts/Footer/FooterOne/FooterOne.component";
import { FixedHeaderComponent } from "./Layouts/Header/FixedHeader/FixedHeader.component";
import { HeaderTwoComponent } from "./Layouts/Header/HeaderTwo/HeaderTwo.component";
import { MenuComponent } from "./Layouts/Menu/Menu/Menu.component";
import { SideBarMenuComponent } from "./Layouts/Menu/SidebarMenu/SidebarMenu.component";
import { PaymentDetailSideBarComponent } from "./Layouts/PaymentDetailSideBar/PaymentDetailSideBar.component";
import { CartComponent } from "./Pages/Cart/Cart.component";
import { CompareProductComponent } from "./Pages/compare-product/compare-product.component";
import { FavoritesComponent } from "./Pages/favorites/favorites.component";
import { HomeTwoComponent } from "./Pages/Home/HomeTwo/HomeTwo.component";
import { InstallmentPlansComponent } from "./Pages/installment-plans/installment-plans.component";
import { NotFoundComponent } from "./Pages/NotFound/NotFound.component";
import { UnderConstructionComponent } from "./Pages/UnderConstruction/UnderConstruction.component";
import { AppInterceptor } from "./Services/app-interceptor";
import { EmbryoService } from "./Services/Embryo.service";
import { TemplatesModule } from "./Templates/Templates.module";
import { ServiceWorkerModule } from "@angular/service-worker";
import { environment } from "../environments/environment.prod";
import { ToastrModule } from "ngx-toastr";
import { LoadingModule } from "./Global/loading/loading.module";
import { PrescriptionGuard } from "./Core/guards/prescription.guard";
import { MarketingService } from "./Services/marketing.service";
import { DownloadAppComponent } from "./Layouts/download-app/download-app.component";
import { SoftbarComponent } from "./Layouts/softbar/softbar.component";
import { NotAvailableComponent } from "./Pages/not-available/not-available.component";
import { CookiePopupComponent } from "./cookie-popup/cookie-popup.component";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { TermsAndConditionsComponent } from "./terms-and-conditions/terms-and-conditions.component";
import { CookiePolicyComponent } from "./cookie-policy/cookie-policy.component";
import { FreePointsGuard } from "./Core/guards/freePoints.guard";
import { SlugNameService } from "./Services/slug-name.service";
import { ProductsListComponent } from "./Pages/Products/ProductsList/ProductsList.component";
import { DetailPageComponent } from "./Pages/Products/DetailPage/DetailPage.component";
import { BreadCrumbsModule } from "./Global/components/bread-crumbs/bread-crumbs/bread-crumbs.module";
import { SourceIconsModule } from "./source-icons/source-icons.module";
import { MultiSahredComponentsModule } from "./multi-sahred-components/multi-sahred-components.module";
import { BarRatingModule } from "ngx-bar-rating";
import { PdfPreviewerComponent } from "./Pages/pdf-previewer/pdf-previewer.component";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { BlogComponent } from "./Pages/blog/blog.component";
import { BlogDetailsComponent } from "./Pages/blog-details/blog-details.component";
// import { AuthLoginAfterSelectZoneGuard } from "./Core/guards/auth-login-after-select-zone.guard";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true,
};

registerLocaleData(arSaLocale);

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
    declarations: [
        AppComponent,
        HomeTwoComponent,
        FavoritesComponent,
        CartComponent,
        NotificationsComponent,
        CompareProductComponent,
        PdfPreviewerComponent,
        BlogComponent,
        BlogDetailsComponent,
        NotFoundComponent,
        SideBarMenuComponent,
        PaymentDetailSideBarComponent,
        FixedHeaderComponent,
        HeaderTwoComponent,
        FooterOneComponent,
        MenuComponent,
        InstallmentPlansComponent,
        DownloadAppComponent,
        SoftbarComponent,
        NotAvailableComponent,
        UnderConstructionComponent,
        CookiePopupComponent,
        PrivacyPolicyComponent,
        TermsAndConditionsComponent,
        CookiePolicyComponent,
        ProductsListComponent,
        DetailPageComponent,
    ],
    imports: [
        BarRatingModule,
        SwiperModule,
        MultiSahredComponentsModule,
        BrowserModule.withServerTransition({ appId: "embryo-seo-pre" }),
        BrowserAnimationsModule,
        RouterModule.forRoot(AppRoutes, {
            scrollPositionRestoration: "enabled",
        }),
        GlobalModule,
        SourceIconsModule,
        NgxExtendedPdfViewerModule,
        TemplatesModule,
        MatFormFieldModule,
        MatButtonModule,
        FlexLayoutModule,
        MatCardModule,
        MatMenuModule,
        MatToolbarModule,
        MatIconModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatProgressSpinnerModule,
        MatTableModule,
        MatExpansionModule,
        MatSelectModule,
        MatSnackBarModule,
        MatTooltipModule,
        MatChipsModule,
        MatListModule,
        MatSidenavModule,
        MatTabsModule,
        MatProgressBarModule,
        MatCheckboxModule,
        MatSliderModule,
        MatRadioModule,
        MatDialogModule,
        MatGridListModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        LoadingBarRouterModule,
        LoadingBarModule,
        LoadingModule,
        NgxPaginationModule,
        ToastaModule.forRoot(),
        ToastrModule.forRoot(),
        BidiModule,
        PerfectScrollbarModule,
        BreadCrumbsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        NgxImageZoomModule,
        OwlModule,
        ServiceWorkerModule.register("ngsw-worker.js", {
            enabled: environment.production,
            registrationStrategy: "registerWhenStable:50000",
        }),
    ],
    providers: [
        MenuItems,
        AuthGuard,
        AuthLoginGuard,
        PrescriptionGuard,
        FreePointsGuard,
        EmbryoService,
        MarketingService,
        // AuthLoginAfterSelectZoneGuard,
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
        },
        { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true },
        { provide: LOCALE_ID, useValue: "ar-EG" },
        SlugNameService,
    ],
    exports: [
        RouterModule,
        TranslateModule,
        TemplatesModule,
        MatFormFieldModule,
        MatButtonModule,
        FlexLayoutModule,
        MatCardModule,
        MatMenuModule,
        MatToolbarModule,
        MatIconModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatProgressSpinnerModule,
        MatTableModule,
        MatExpansionModule,
        MatSelectModule,
        MatSnackBarModule,
        MatTooltipModule,
        MatChipsModule,
        MatListModule,
        MatSidenavModule,
        MatTabsModule,
        MatProgressBarModule,
        MatCheckboxModule,
        MatSliderModule,
        MatRadioModule,
        MatDialogModule,
        MatGridListModule,
    ],

    bootstrap: [AppComponent],
})
export class AppModule {}
